module.exports = function () {
  var html = "\n      <div class=\"treatise-overlay\" id=\"treatise-overlay\">\n      </div>\n  ";
  return html;
};